import Layout from "../../components/shared/layout/layout";
import Seo from "../../components/shared/seo/seo";

export default function Impressum(){
    return (
        <Layout>
            <Seo title="Impressum" description="Impressum des Weinguts Gisperg." path="/impressum" />
            <section className="no_fill small background_light">
                <h1>Impressum</h1>
                <div className="horizontal">
                <div className="col-6 left">
                    <p>
                    Weingut Johann Gisperg
                    </p>
                    <p>
                    Gisperg Johann & Mitgesellschafter GesnbR<br/>
                    Hauptstrasse 14<br/>
                    A-2524 Teesdorf<br/>
                    Österreich
                    </p>
                    <p>
                    UID Nummer: ATU17532908<br/>
                    Betriebsnummer: 1903012
                    </p>
                    <p>
                    Tel: <a  className="underline" href="tel:+43 / 2253/814 64">+43 / 2253/814 64</a> <br/>
                    Fax: +43 / 2253/814 64 50 <br/>
                    email: <a  className="underline" href="mailto:wein@weingut-gisperg.at">wein@weingut-gisperg.at</a>
                    </p>
                </div>
                <div className="col-6 right">
                    <p> Copyright-Hinweis</p>
                    <p>Verwendungsberechtigung durch Wienerwald Tourismus &#169;</p>
                </div>
                </div>
            </section>
        </Layout>
    );
}